import React, { useContext, useEffect, useState } from 'react'
import { Button } from '@chakra-ui/react'
import { useNavigate } from 'react-router-dom';

import { ClientPicker } from '../../Components/Molecules';

import { Sheet } from '../../Templates';
import VehiclesLeased from './VehiclesLeased';

import { StoreContext } from '../../Library/contexts';
import { WIDGET_TYPES } from '../../Library/widgets';

import { AddModelIcon, AddClientPlaceholder } from '../../Assets/images/svgs';

import { getClients } from '../../APIs';

import "./style.css"

const LEASE_LAYOUT = [
  [ WIDGET_TYPES.CO2_STATS ],
  [ WIDGET_TYPES.PAYMENT_STATS ],
]

const Lease = () => {
  const navigate = useNavigate();

  const { constants, filters } = useContext(StoreContext);

  return (
    <section className="panel-main">
      {constants.clients.length ? (
        <>
          <header className='panel-filters lease-main-page-header'>
            <Button
              leftIcon={<AddModelIcon />} className="panel-button add-new-modal-btn"
              onClick={() => navigate("/lease/addclient")}>
              Add new client
            </Button>
            <ClientPicker />
          </header>

          <VehiclesLeased client={constants.clientMap[filters.client]} />

          <article className="widget-main">
            <main>
              <Sheet layout={LEASE_LAYOUT}/>
            </main>
          </article>
        </>) : <NoClientPage navigate={navigate} />}
    </section>
  )
}

const NoClientPage = ({navigate}) => {
  return (
    <div className='no-client-page-container'>
      <AddClientPlaceholder />
      <h1 className='no-client-add-page-text'>No client added yet!</h1>
      <Button leftIcon={<AddModelIcon />} className="panel-button add-new-modal-btn" onClick={() => navigate("/lease/addclient")}>Add New Client</Button>
    </div>
  )
}

export default Lease
